import { Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";

import Loader from "../../../../../components/Loader";

const RefNumber: FC<any> = (props) => {
  const service = props.record;
  const [refNumb, setRefNumber] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsub: any;
    if (service && service.refNumber) {
      setRefNumber(service.refNumber);
      setLoading(false);
    } else {
      unsub = service?.ref?.onSnapshot((snapshot: any) => {
        if (snapshot.exists && snapshot.data().refNumber) {
          setRefNumber(snapshot.data().refNumber);
          setLoading(false);
        }
      });
    }

    return () => {
      unsub?.();
    };
  }, [service]);

  return (
    <Loader loading={loading}>
      <Typography variant="body2">{refNumb}</Typography>
    </Loader>
  );
};

export default RefNumber;
